import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll";

export const Nav = styled.nav`
  height: 82px;
  position: sticky;
  top: 0;
  z-index: 1000;

  display: flex;
  justify-content: center;
  align-items: center;

  background: ${({ scrollNav }) =>
    scrollNav ? "rgba(0, 0, 0, 0.72)" : "rgba(0, 0, 0, 0.96)"};

  backdrop-filter: ${({ scrollNav }) => (scrollNav ? "blur(14px)" : "none")};
  -webkit-backdrop-filter: ${({ scrollNav }) =>
    scrollNav ? "blur(14px)" : "none"};

  border-bottom: ${({ scrollNav }) =>
    scrollNav
      ? "1px solid rgba(255,255,255,0.12)"
      : "1px solid rgba(255,255,255,0.07)"};

  transition:
    background 0.25s ease,
    backdrop-filter 0.25s ease,
    border 0.25s ease;

  @media screen and (max-width: 820px) {
    height: 74px;
  }

  @media screen and (max-width: 768px) {
    height: 76px;
  }
`;

export const NavbarContainer = styled.div`
  width: 100%;
  max-width: 1380px;
  padding: 0 22px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;

  @media screen and (max-width: 820px) {
    max-width: 100%;
    padding: 0 14px;
    gap: 10px;
  }

  @media screen and (max-width: 480px) {
    padding: 0 14px;
  }
`;

export const NavLogo = styled(LinkR)`
  display: flex;
  align-items: center;
  gap: 10px;

  text-decoration: none;
  cursor: pointer;
  user-select: none;

  padding: 6px 8px;
  border-radius: 14px;

  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }

  img {
    height: 58px;
    width: auto;
    display: block;
    object-fit: contain;
    filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.35));
  }

  @media screen and (max-width: 820px) {
    padding: 4px 6px;

    img {
      height: 46px;
    }
  }

  @media screen and (max-width: 768px) {
    img {
      height: 50px;
    }
  }

  @media screen and (max-width: 480px) {
    img {
      height: 44px;
    }
  }
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 44px;
    height: 44px;
    border-radius: 14px;

    cursor: pointer;
    color: #fff;

    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);

    transition: transform 0.15s ease, background 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.14);
    }

    &:active {
      transform: scale(0.96);
    }

    svg {
      font-size: 18px;
    }
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 8px;

  list-style: none;
  margin: 0;
  padding: 0;

  @media screen and (max-width: 820px) {
    gap: 4px;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  display: flex;
  align-items: center;
  min-height: 82px;

  @media screen and (max-width: 820px) {
    min-height: 74px;
  }
`;

export const NavLinks = styled(LinkS)`
  color: rgba(255, 255, 255, 0.88);
  display: flex;
  align-items: center;

  text-decoration: none;
  padding: 10px 14px;
  border-radius: 999px;

  cursor: pointer;
  font-weight: 800;
  font-size: 14px;
  white-space: nowrap;

  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.07);
    color: #ffffff;
    transform: translateY(-1px);
  }

  &.active {
    background: rgba(212, 175, 55, 0.14);
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(212, 175, 55, 0.3);
  }

  @media screen and (max-width: 820px) {
    padding: 8px 10px;
    font-size: 12px;
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  @media screen and (max-width: 820px) {
    gap: 6px;
  }
`;

export const NavBtnLink = styled(LinkR)`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-height: 42px;
  padding: 0 16px;
  border-radius: 999px;

  background: ${({ $secondary, $danger }) =>
    $danger
      ? "rgba(239,68,68,0.92)"
      : $secondary
      ? "rgba(255,255,255,0.08)"
      : "linear-gradient(135deg, rgba(0,103,114,0.96), rgba(212,175,55,0.88))"};

  border: 1px solid
    ${({ $secondary }) =>
      $secondary ? "rgba(255,255,255,0.14)" : "rgba(255,255,255,0.16)"};

  color: #fff;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0.2px;
  white-space: nowrap;

  text-decoration: none;
  cursor: pointer;

  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.34);

  transition:
    transform 0.15s ease,
    background 0.2s ease,
    color 0.2s ease,
    border 0.2s ease;

  &:hover {
    background: ${({ $danger }) =>
      $danger
        ? "rgba(255,255,255,0.95)"
        : "rgba(255,255,255,0.95)"};
    color: #0b0f14;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media screen and (max-width: 820px) {
    min-height: 38px;
    padding: 0 12px;
    font-size: 12px;
  }
`;